import { store } from '@src/redux/configureStore'
import type { ResourceTypeEnum } from '@src/endpoints/services/commonHdr.service'
import { parseCamURI } from './url.utils'
import { generateUrl } from './router.helpers'
import { Routes } from '@src/constants/routes'

export function getUrlResourcePage(typeName: ResourceTypeEnum) {
  const { getState } = store
  const { shell } = getState()
  const { resourceTypes = {} } = shell
  const { object_type, identity_type, network_type } =
    resourceTypes[typeName] || {}
  //First of all, check if it is identity
  if (identity_type) return 'identities'
  if (object_type) return 'objects'
  if (network_type) return 'networks'
  return null
}

export function getMetaLabel(typeName: ResourceTypeEnum) {
  const { getState } = store
  const { shell } = getState()
  const { resourceTypes = {} } = shell
  const { meta_label } = resourceTypes[typeName]
  return meta_label
}

function getParamsLink(uri: string) {
  const { tenantId, cloudType, accountId, region, type, id } =
    parseCamURI(uri) || {}
  const page = getUrlResourcePage(type)
  if (!page) {
    return null
  }
  const metaLabel = getMetaLabel(type)

  return {
    type,
    metaLabel,
    params: {
      page,
      tenantId,
      cloudType,
      accountId,
      region,
      type: metaLabel || type,
      id
    }
  }
}

export function generateScopeDetailsLink(roleUri: string, scopeUri: string) {
  try {
    const data = getParamsLink(roleUri)
    if (!data || !scopeUri) {
      return null
    }
    const { type, metaLabel, params } = data
    if (metaLabel) {
      return generateUrl(Routes.patternRoleScopePath, {
        ...params,
        scopeUri,
        resourceType: type
      })
    }
    return generateUrl(Routes.patternRoleScopePath, {
      ...params,
      scopeUri
    })
  } catch (ex) {
    return null
  }
}

export default function generateDetailsLink(uri: string) {
  try {
    const data = getParamsLink(uri)
    if (!data) {
      return null
    }

    const { type, metaLabel, params } = data
    if (metaLabel) {
      return generateUrl(Routes.patternPath, { ...params, resourceType: type })
    }
    return generateUrl(Routes.patternPath, { ...params })
  } catch (ex) {
    return null
  }
}
